export default function signInValidation(values) {
    let errors = {};
    if (!values.first_name.trim()) {
        errors.first_name = 'First Name is a required field';
    }
    if (!values.last_name.trim()) {
        errors.last_name = 'Last Name is a required field';
    }
    if (
        !/@(?!hotmail|aol|live|outlook|gmail|yahoo|gmailer|ayahoo|onetel|protonmail|icloud)(([a-zA-Z\d-]+\.)+)/i.test(
            values.email
        )
    ) {
        errors.email = 'Invalid email address';
    }
    if (values.password.length < 8) {
        errors.password = 'Your password must be at least 8 characters long';
    }
    return errors;
}

export const emailValid = email => {
    if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
        return true;
    }
    return false;
};

export const onlyNumber = value => {
    if (/^[0-9]*$/gm.test(value)) {
        return true;
    }
    return false;
};
